// Receipt functionality - Modular facade
// This file re-exports all receipt-related functions from their respective modules
// for backward compatibility with existing code

// Main view rendering
export { renderReceiptView, renderHeaderReceiptIcon } from './receiptView.mjs';

// Item and charge editing
export {
    openItemModal,
    editItem,
    deleteItem,
    addItem,
    editCharge,
    deleteCharge,
    editExpenseDetails,
    openPayerSelector
} from './receiptItemEditor.mjs';

// Assignment functionality
export {
    openAssignmentModal,
    unassignParticipant
} from './receiptAssignment.mjs';

// Receipt drawer (image viewer)
export {
    openReceiptDrawer,
    updateReceiptVisibility,
    generateQRCodeSVG
} from './receiptDrawer.mjs';

// State management
export {
    selectedItems,
    currentExpense,
    currentParticipants,
    selectionHistoryStatePushed,
    resetSelectedItems,
    setSelectedItem,
    getTotalSelectedCount,
    setCurrentView
} from './receiptState.mjs';
